import React, { useLayoutEffect } from "react";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import {
  PAGE_SPINNER_MARGIN_FROM_TOP,
  QUICK_ONBOARDING_PATH,
} from "common/constants.ts";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay.tsx";
import { useTheme } from "styled-components";
import useDrawers from "common/Home/useDrawers.tsx";

const Drawers = () => {
  const theme = useTheme();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const { paths, drawers, visitedIndices, setVisitedIndices, currentMatch } =
    useDrawers();

  useLayoutEffect(() => {
    if (currentMatch !== undefined && !visitedIndices[currentMatch]) {
      setVisitedIndices((prevVisited) => {
        const updated = [...prevVisited];
        updated[currentMatch] = true;
        return updated;
      });
    }
  }, [currentMatch]);

  return (
    <React.Suspense
      fallback={
        <LoadingSpinnerOverlay
          isLoading={true}
          spinnerMarginTop={PAGE_SPINNER_MARGIN_FROM_TOP}
          spinnerSize="large"
          backgroundColor={theme.colors.layoutBgColor}
          zIndex={2}
        />
      }
    >
      {visitedIndices.map((shouldRender, index) => {
        const path = paths[index];
        if (
          shouldRender &&
          (path !== QUICK_ONBOARDING_PATH || !isBottomNavigator)
        ) {
          return drawers[index];
        }
        return null;
      })}
    </React.Suspense>
  );
};

export default Drawers;
